$(document).ready(function () {
    let validatedInput = $('.password-validation');
    validatedInput.wrap('<div class="password-strength"></div>');

    validatedInput.on('propertychange change keyup paste input', function () {

        let input = $(this);
        let inputParent = input.parent();

        let password = $(this).val();
        let passwordScore = zxcvbn(password)['score'];

        // Lokalizované popisky síly hesla — čteme z data-atributů na inputu (plní je
        // formuláře přes appTranslator). Když chybí (neinternacionalizovaný formulář),
        // padáme na češtinu, takže se chování nikde nerozbije.
        const t = {
            label:      input.attr('data-strength-label')       || 'Síla hesla',
            none:       input.attr('data-strength-none')        || 'žádná',
            veryWeak:   input.attr('data-strength-very-weak')   || 'velmi slabé',
            weak:       input.attr('data-strength-weak')        || 'slabé',
            medium:     input.attr('data-strength-medium')      || 'střední',
            strong:     input.attr('data-strength-strong')      || 'silné',
            veryStrong: input.attr('data-strength-very-strong') || 'velmi silné',
        };

        if(!inputParent.find(".password-strength").length && !inputParent.hasClass('password-strength')){
            input.wrap('<div class="password-strength"></div>');
            input.focus();
            inputParent = inputParent.find(".password-strength");
        }

        if(inputParent.hasClass("password-strength")) {

            // TODO: only use the first 128 characters to stop this from blocking the browser if a giant password is entered
            const updateMeter = function (width, background, backgroundText, text) {

                if (!inputParent.find(".password-background").length) {
                    inputParent.append('<div class="password-background"></div>');
                }
                if (!inputParent.find(".strength").length) {
                    inputParent.append('<div class="strength"></div>');
                }

                inputParent.find('.password-background').css({"width": width, "background-color": background});
                inputParent.find('.strength').text(t.label + ': ' + text).css('color', backgroundText);
            };

            if (passwordScore === 0) {
                if (password.length === 0) {
                    updateMeter("0%", "#ffa0a0", "#a94442", t.none);
                } else {
                    updateMeter("20%", "#ffa0a0", "rgb(189, 107, 107)", t.veryWeak);
                }
            }

            if (passwordScore === 1) updateMeter("40%", "#ffb78c", "rgb(210, 118, 63)", t.weak);
            if (passwordScore === 2) updateMeter("60%", "#ffec8b", "rgb(189, 171, 77)", t.medium);
            if (passwordScore === 3) updateMeter("80%", "#c3ff88", "rgb(122, 155, 90)", t.strong);
            if (passwordScore === 4) updateMeter("100%", "#ACE872", "rgb(92, 132, 54)", t.veryStrong);

        }

    });

    /*
    // TODO: add ie 8/7 support, what browsers didnt support this check market share
    $('.show-password').click(function (event) {
        event.preventDefault();
        let elem = $(this);
        if (elem.parent().find('.password-validation').attr('type') === 'password') {
            elem.parent().find('.password-validation').attr('type', 'text');
            elem.parent().find('.show-password').text('Skrýt heslo');
        } else {
            $('#password').attr('type', 'password');
            elem.parent().find('.password-validation').text('Zobrazit heslo');
        }
    });
    */

});
